module.exports = __webpack_public_path__ + "img/1.c5d4438f.jpg";